<template>
  <div class="row" v-if="!paid">
    <div class="col-md-12">
      <div class="form-group authorize-elements">
        <form id="paymentForm">
          <h5 class="text-center">
            {{ computeCaption(this.fields_en['payment_details'], this.$store.state.lang.value.toLowerCase()) }}</h5>
          <div class="row">
            <div class="col-md-5 col-md-offset-1">
              <div class="group text-center">
                <label for="cardHolderName">
                  <span class="card-label">{{
                      computeCaption(this.fields_en['first_name'], this.$store.state.lang.value.toLowerCase())
                    }}</span>
                  <input
                    class="field col-md-6"
                    type="text"
                    maxlength="17"
                    name="cardHolderFirstName"
                    id="firstName"
                    placeholder="John"
                    v-model="firstName"
                    onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
                  />
                </label>
              </div>
              <div v-if="cardErrors.firstName" class="text-danger">
                <small>{{ computeCaption(cardErrors.firstName, this.$store.state.lang.value.toLowerCase()) }}</small>
              </div>
            </div>
            <br class="pc-hidden">
            <div class="col-md-5">
              <div class="group text-center">
                <label for="cardHolderName">
                  <span class="card-label">{{
                      computeCaption(this.fields_en['last_name'], this.$store.state.lang.value.toLowerCase())
                    }}</span>
                  <input
                    class="field col-md-6"
                    type="text"
                    name="cardHolderLastName"
                    id="lastName"
                    placeholder="Doe"
                    v-model="lastName"
                    onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
                  />
                </label>
              </div>
              <div v-if="cardErrors.lastName" class="text-danger">
                <small>{{ computeCaption(cardErrors.lastName, this.$store.state.lang.value.toLowerCase()) }}</small>
              </div>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-md-10 col-md-offset-1">
              <div class="group text-center">
                <label for="card">
                  <span class="card-label">{{
                      computeCaption(this.fields_en['card'], this.$store.state.lang.value.toLowerCase())
                    }}</span>
                  <input
                    class="field card-number"
                    ref="cardNumber"
                    v-cardformat:formatCardNumber
                    name="cardNumber"
                    id="cardNumber"
                    maxlength="19"
                    placeholder="1234 1234 1234 1234"
                    v-model="cardNumber"
                    :data-error="(cardErrors.cardNumber)?true:false">
                </label>
              </div>
              <div v-if="cardErrors.cardNumber" class="text-danger">
                <small>{{ computeCaption(cardErrors.cardNumber, this.$store.state.lang.value.toLowerCase()) }}</small>
              </div>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-md-5 col-md-offset-1">
              <div class="group text-center">
                <label for="expiry">
                  <span class="card-label">{{
                      computeCaption(this.fields_en['card_expiration'], this.$store.state.lang.value.toLowerCase())
                    }}</span>
                  <input
                    ref="cardExpiry"
                    name="cardExpiry"
                    id="card-exp"
                    :data-error="(cardErrors.cardExpiry)?true:false"
                    v-model="cardExpiry"
                    maxlength="4"
                    class="field col-md-6"
                    placeholder="MM / YY"
                    v-cardformat:formatCardExpiry>
                </label>
              </div>
              <div v-if="cardErrors.cardExpiry" class="text-danger">
                <small>{{ computeCaption(cardErrors.cardExpiry, this.$store.state.lang.value.toLowerCase()) }}</small>
              </div>
            </div>
            <br class="pc-hidden">
            <div class="col-md-5">
              <div class="group text-center">
                <label for="cvc">
                  <span class="card-label">{{
                      computeCaption(this.fields_en['cvc'], this.$store.state.lang.value.toLowerCase())
                    }}</span>
                  <input
                    ref="cardCvc"
                    id="cardCode"
                    name="cardCode"
                    :data-error="(cardErrors.cardCvc)?true:false"
                    v-model="cardCvc"
                    class="field col-md-6"
                    v-cardformat:formatCardCVC
                    placeholder="CVC">
                </label>
              </div>
              <div v-if="cardErrors.cardCvc" class="text-danger">
                <small>{{ computeCaption(cardErrors.cardCvc, this.$store.state.lang.value.toLowerCase()) }}</small>
              </div>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-md-10 col-md-offset-1">
              <div class="group text-center">
                <label for="zip">
                  <span class="card-label">{{
                      computeCaption(this.fields_en['zipcode'], this.$store.state.lang.value.toLowerCase())
                    }}</span>
                  <input
                    class="field"
                    name="zip"
                    id="zip"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    type="number"
                    maxlength="5"
                    v-model="cardZip"
                    placeholder="90210"
                    onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
                  />
                </label>
              </div>
              <div v-if="cardErrors.zipcode" class="text-danger">
                <small>{{ computeCaption(cardErrors.zipcode, this.$store.state.lang.value.toLowerCase()) }}</small>
              </div>
            </div>
          </div>
          <br>
          <div class="row">
            <div v-if="cardErrors.generalError" class="col-md-10 col-md-offset-1">
              <small class="text-danger">{{
                  computeCaption(cardErrors.generalError, this.$store.state.lang.value.toLowerCase())
                }}</small>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="col-md-12">
      <div class="form-group">
        <h5 class="text-center">
          {{ computeCaption(this.fields_en['payment_received'], this.$store.state.lang.value.toLowerCase()) }}.
          <br>{{ computeCaption(this.fields_en['check_email'], this.$store.state.lang.value.toLowerCase()) }}!</h5>
        <h4 class="text-center">
          {{ computeCaption(this.fields_en['thank_you'], this.$store.state.lang.value.toLowerCase()) }}!</h4>
      </div>
    </div>
  </div>
</template>
<script>
import {FormatterUtils} from '../../../../../../utils/Formatter'
import {AmountUtils} from '../../../../../../utils/Amount'
import {SettingsUtils} from '../../../../../../utils/SiteConfigurations'
import {TranslationsUtils} from '../../../../../../utils/Translations'
import {QuestionUtils} from '../../../../../../utils/Questions'
import {PatientInfoUtils} from '../../../../../../utils/PatientInfo'

export default {
  mixins: [FormatterUtils, AmountUtils, SettingsUtils, TranslationsUtils, QuestionUtils, PatientInfoUtils],
  props: ['paid'],
  data () {
    return {
      fields_en: {
        registration_sucessful: 'Registration sucessful, a confirmation email was sent to',
        disclaimer: 'DISCLAIMER',
        amount_to_be_charged: 'Based on your answers, the amount to be charged on credit card:',
        payment_details: 'Please provide your payment details',
        first_name: 'First Name',
        last_name: 'Last Name',
        card: 'Card',
        card_expiration: 'Card Expiration',
        cvc: 'CVC',
        zipcode: 'Zipcode',
        payment_received: 'Your Payment Has Been Successfully Received',
        check_email: 'Please check your email for confirmation',
        thank_you: 'Thank you for your payment'
      },
      amount: 0,
      errorCardHolderName: '',
      errorMessage: '',
      stripeOptions: {
        showIcon: true
      },
      cardHolderName: '',
      allowSitePayment: this.isTrue(this.$store.state.configs.ALLOW_SITE_PAYMENT),
      paymentMethod: 'card',
      userPaid: false,
      number: false,
      expiry: false,
      cvc: false,
      cardZip: '',
      complete: false,
      monthError: '',
      formatCardNumber: '',
      formatCardExpiry: '',
      formatCardCVC: '',
      cardErrors: {
        firstName: '',
        lastName: '',
        cardNumber: '',
        cardExpiry: '',
        cardCvc: '',
        zipcode: ''
      },
      validationObject: {
        firstName: false,
        lastName: false,
        cardNumber: false,
        cardExpiry: false,
        cardCvc: false,
        cardZip: false
      },
      cardNumber: '',
      cardExpiry: '',
      cardCvc: '',
      firstName: '',
      lastName: ''
    }
  },
  beforeMount () {
  },
  methods: {
    validate: function () {
      if (this.$cardFormat.validateCardNumber(this.cardNumber) && this.$cardFormat.validateCardExpiry(this.cardExpiry) && this.$cardFormat.validateCardCVC(this.cardCvc) && this.firstName && this.lastName && this.cardZip) {
        this.complete = true
        let cardData = {}
        cardData.lastName = this.lastName
        cardData.firstName = this.firstName
        cardData.cardNumber = this.cardNumber
        cardData.cardNumber = cardData.cardNumber.split(' ').join('')
        let expiryDate = this.cardExpiry
        cardData.month = expiryDate.split(' ')[0]
        cardData.year = expiryDate.split(' ')[2].slice(-2)
        cardData.cardCode = this.cardCvc
        cardData.zip = this.cardZip
        return cardData
      }
      this.cardErrors = {}
      if (this.cardZip === '') {
        this.cardErrors.zipcode = 'Zipcode is required'
        document.getElementsByName('zip')[0].focus()
      }

      if (!this.$cardFormat.validateCardCVC(this.cardCvc)) {
        document.getElementsByName('cardCode')[0].focus()
        this.cardErrors.cardCvc = 'Invalid CVC'
      }

      if (!this.$cardFormat.validateCardExpiry(this.cardExpiry)) {
        document.getElementsByName('cardExpiry')[0].focus()
        this.cardErrors.cardExpiry = 'Invalid Expiration Date'
      }

      if (!this.$cardFormat.validateCardNumber(this.cardNumber)) {
        document.getElementsByName('cardNumber')[0].focus()
        this.cardErrors.cardNumber = 'Invalid Credit Card Number'
      }

      if (this.lastName.length < 3) {
        document.getElementsByName('cardHolderLastName')[0].focus()
        this.cardErrors.lastName = 'Last Name field must be at least 3 characters'
      }

      if (this.firstName.length < 3) {
        document.getElementsByName('cardHolderFirstName')[0].focus()
        this.cardErrors.firstName = 'First Name field must be at least 3 characters'
      }
      this.$emit('validateSection', false)
      return false
    }
  },
  watch: {
    'validationObject': {
      handler: function (val) {
        if (Object.values(val).every(field => field === true)) {
          this.$emit('validateSection', true)
        } else {
          this.$emit('validateSection', false)
        }
      },
      deep: true
    },
    'cardZip': {
      handler: function (val) {
        if (this.cardZip) {
          this.cardErrors.zipcode = ''
          this.validationObject.cardZip = true
        } else {
          this.cardErrors.zipcode = 'Zipcode is required'
          this.validationObject.cardZip = false
        }
      }
    },
    firstName () {
      if (this.firstName === '') {
        this.cardErrors.firstName = 'First Name field cannot be empty'
        this.validationObject.firstName = false
      } else if (this.firstName.length < 3) {
        this.cardErrors.firstName = 'First Name field must be at least 3 characters'
        this.validationObject.firstName = false
      } else {
        this.cardErrors.firstName = ''
        this.validationObject.firstName = true
      }
    },
    lastName () {
      if (this.lastName === '') {
        this.cardErrors.lastName = 'Last Name field cannot be empty'
        this.validationObject.lastName = false
      } else if (this.lastName.length < 3) {
        this.cardErrors.lastName = 'Last Name field must be at least 3 characters'
        this.validationObject.lastName = false
      } else {
        this.cardErrors.lastName = ''
        this.validationObject.lastName = true
      }
    },
    cardNumber () {
      if (this.cardNumber === '') {
        this.cardErrors.cardNumber = 'Card Number field cannot be empty'
        this.validationObject.cardNumber = false
      } else if (!this.$cardFormat.validateCardNumber(this.cardNumber)) {
        this.cardErrors.cardNumber = 'Invalid Credit Card Number'
        this.validationObject.cardNumber = false
      } else {
        this.cardErrors.cardNumber = ''
        this.validationObject.cardNumber = true
      }
    },
    cardExpiry () {
      if (this.cardExpiry === '') {
        this.cardErrors.cardExpiry = 'Card Expiration field cannot be empty'
        this.validationObject.cardExpiry = false
      } else if (!this.$cardFormat.validateCardExpiry(this.cardExpiry)) {
        this.cardErrors.cardExpiry = 'Invalid Expiration Date'
        this.validationObject.cardExpiry = false
      } else {
        this.cardErrors.cardExpiry = ''
        this.validationObject.cardExpiry = true
      }
    },
    cardCvc () {
      if (this.cardCvc === '') {
        this.cardErrors.cardCvc = 'CVC field cannot be empty'
        this.validationObject.cardCvc = false
      } else if (!this.$cardFormat.validateCardCVC(this.cardCvc)) {
        this.cardErrors.cardCvc = 'Invalid CVC'
        this.validationObject.cardCvc = false
      } else {
        this.cardErrors.cardCvc = ''
        this.validationObject.cardCvc = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../../assets/sass/paper/variables';
.margin-justified {
  margin-left:20px; margin-right:20px
}
.price-breakdown {
  border: 1px solid $default-grey;
  margin-bottom: 15px;
  padding: 5px 0px;
}
.background-grey {
  background-color: $default-grey;
}

.pc-hidden {
  display: none;
}

#card-errors{
  color: #f83f37;
}

.f-right{
  float: right;
}

.group {
  background: white;
  box-shadow: 0px 1px 3px #E7E8E9 !important;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
}

label {
  position: relative;
  color: #31325F;
  font-weight: 300;
  height: 40px;
  line-height: 40px;
  margin-left: 20px;
  display: flex;
  flex-direction: row;
}

label > span {
  width: 80px;
  text-align: left;
}

.field {
  background: transparent;
  font-weight: 300;
  border: 0;
  color: #31325F;
  outline: none;
  flex: 1;
  padding-right: 10px;
  padding-left: 10px;
  cursor: text;
  padding-top: 0;
}

.radio-label{
  color: #474644;
  font-weight: bold;
  padding: 0;
  margin: 0;
}

.radio {
  margin: 0;
  margin-left: 10px;
}

.mt-6{
  margin-top: 6px;
}

.loading{
  margin-top: 30px;
}

.mt-30 {
  margin-top: 30px;
}

.authorize-elements label {
  margin-bottom: 0;
}

.card-label {
  line-height: 14px;
  font-size: 14px;
  text-align: left;
  display: flex;
  align-items: center;
}

@media screen and (max-width: 550px) {
  label > span {
    width: 40px;
    text-align: left;
    margin-right: 10px;
  }

  .field {
    background: transparent;
    font-weight: 300;
    border: 0;
    color: #31325F;
    outline: none;
    flex: 1;
    padding-right: 10px;
    padding-left: 40px;
    cursor: text;
    padding-top: 0;
  }
}

@media screen and (max-width: 990px) {
  .pc-hidden {
    display: block;
  }
}
@media screen and (max-width: 1720px) {
  .mt-8 {
    margin-top: 0px;
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/SubComponents/PaymentParts/cardSectionAuthorize.vue